import { DiscountState } from '../state';

export const clearDiscountReducer = (state: DiscountState) => {
  state.data = null;
  state.error = '';
  state.loading = false;
};
